module.exports = __webpack_public_path__ + "static/team_5-fb83cacb6dd387d74ade7dd58cc7caf5.jpg";